;(function($){

    function Infinity_pagination() {
        
        $('ul.pagination').hide();   

        $(function() {
            $('.infinite-scroll').jscroll({
                autoTrigger: true,
                loadingHtml: '<img class="center-block" src="'+$("#app_url").val() +'/public/img/loading-scroll.gif" alt="Loading..." />',
                padding: 0,
                nextSelector: '.pagination li.active + li a',
                contentSelector: 'div.infinite-scroll',
                callback: function() {
                   $('.infinite-scroll ul.pagination').remove();

                   $(".anu").ayoshare({
                    counter: false,
                    button: {
                        google : true,
                        facebook : true,
                        pinterest : true,
                        linkedin : false,
                        twitter : true,
                        flipboard : false,
                        email : false,
                        whatsapp : false,
                        telegram : false,
                        line : false,
                        bbm : false,
                        viber : false,
                        sms : false
                    }
                  });
                }
            });
        });
    }

   	new Infinity_pagination();

}(jQuery));